import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '@/components/loginPage'
import managePage from '@/components/managePage'
import batteryMgmt from '@/components/deviceMgmt/batteryMgmt'

// import batteryManagement from '@/components/deviceMgmt/batteryManagement'
import rentOrderMgmt from '@/components/orderMgmt/rentOrderMgmt'
import unitMgmt from '@/components/unitMgmt/unitMgmt'
import unitMgmtManageView from '@/components/unitMgmt/unitMgmtManageView'
import unitMgmtAuthoritySchemeEditView from '@/components/unitMgmt/unitMgmtAuthoritySchemeEditView'
import userMgmt from '@/components/unitMgmt/userMgmt'
import authoritySchemeMgmt from '@/components/unitMgmt/authoritySchemeMgmt'
import authoritySchemeMgmtAddView from '@/components/unitMgmt/authoritySchemeMgmtAddView'
import authoritySchemeMgmtEditView from '@/components/unitMgmt/authoritySchemeMgmtEditView'
import batterySwapOrderMgmt from '@/components/orderMgmt/batterySwapOrderMgmt'
import uploadFile from '@/components/common/uploadFile'
import uploadImg from "@/components/common/uploadImg";
import batterySwapMgmt from "@/components/deviceMgmt/batterySwapMgmt";
import electricityStatistics from "@/components/deviceMgmt/electricityStatistics";
import cabinetSetting from "@/components/deviceMgmt/cabinetSetting";
import chargeMgmt from "@/components/deviceMgmt/chargeMgmt";
import downloadTask from "@/components/downloadTask";
import emptyPage from "@/components/emptyPage";
import snapShot from "@/components/deviceMgmt/snapShot";
import sendRecord from "@/components/deviceMgmt/sendRecord";
import stopReason from "@/components/deviceMgmt/stopReason";
import sendRecordTotal from "@/components/deviceMgmt/sendRecordTotal";
import batteryBelongRecord from "@/components/deviceMgmt/batteryBelongRecord";
import electricBicycleBelongRecord from "@/components/deviceMgmt/electricBicycleBelongRecord";
import deviceUpgradeTask from "@/components/deviceMgmt/deviceUpgradeTask";
import batterySnapShot from "@/components/deviceMgmt/batterySnapShot";
import chargeOrderMgmt from "@/components/orderMgmt/chargeOrderMgmt";
import batterySwapCardOrder from "@/components/orderMgmt/batterySwapCardOrder";
import returnOrderMgmt from "@/components/orderMgmt/returnOrderMgmt";
import batteryConsignRecord from "@/components/orderMgmt/batteryConsignRecord";
import batteryMileage from "@/components/deviceMgmt/batteryMileage";
import batteryTrack from "@/components/deviceMgmt/batteryTrack";
import commodityMgmt from "@/components/commodityMgmt/commodityMgmt";
import userInviteRecord from "@/components/unitMgmt/userInviteRecord";
// import marketing from "@/components/marketingMgmt/marketing";
import discount from "@/components/marketingMgmt/discount";
import combo from "@/components/commodityMgmt/combo";
import electricBicycleMgmt from "@/components/deviceMgmt/electricBicycleMgmt";
import warningOverview from "@/components/deviceMgmt/warningOverview";
import warningRuleMgmt from "@/components/warningMgmt/warningRuleMgmt";
import warningRecord from "@/components/warningMgmt/warningRecord";
import installmentOrderMgmt from "@/components/orderMgmt/installmentOrderMgmt";
import chargeCabinetMgmt from "@/components/deviceMgmt/chargeCabinetMgmt";
import voucherMgmt from "@/components/deviceMgmt/voucherMgmt";
import chargeCabinetOrderMgmt from "@/components/orderMgmt/chargeCabinetOrderMgmt";
import displayScreenMgmt from "@/components/deviceMgmt/displayScreenMgmt";
import alermRecord from "@/components/warningMgmt/alermRecord";
import snapShotMgmt from "@/components/orderMgmt/snapShotMgmt";
import batteryConsignRecordBatterySnap from "@/components/orderMgmt/batteryConsignRecordBatterySnap";
import sendRecordMgmt from "@/components/orderMgmt/sendRecordMgmt";
import batteryConsignSendRequestRecord from "@/components/orderMgmt/batteryConsignSendRequestRecord";
import deviceTrack from "@/components/deviceMgmt/deviceTrack";
import rechargeOrderMgmt from "@/components/orderMgmt/rechargeOrderMgmt";
import subAccountMgmt from "../components/orderMgmt/subAccountMgmt";
import marketingActivity from "../components/marketingMgmt/marketingActivity";
import bannerManagement from "../components/marketingMgmt/bannerManagement";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/loginPage',
      name: 'loginPage',
      component: loginPage
    },
    {
      path: '/managePage',
      name: 'managePage',
      component: managePage,
      redirect: '/managePage/batterySwapMgmt',
      children: [
        // {
        //   path: 'emptyPage',
        //   name: 'emptyPage',
        //   component: emptyPage
        // },
        {
          path: 'batteryMgmt',
          name: 'batteryMgmt',
          component: batteryMgmt
        },
        
        // {
        //   path: 'batteryManagement',
        //   name: 'batteryManagement',
        //   component: batteryManagement
        // },
        // {
        //   path: 'batteryMileage',
        //   name: 'batteryMileage',
        //   component: batteryMileage
        // },
        // {
        //   path: 'batteryTrack',
        //   name: 'batteryTrack',
        //   component: batteryTrack
        // },
        {
          path: 'deviceTrack',
          name: 'deviceTrack',
          component: deviceTrack
        },

        {
          path: 'batterySwapMgmt',
          name: 'batterySwapMgmt',
          component: batterySwapMgmt
        },
        {
          path: 'electricityStatistics',
          name: 'electricityStatistics',
          component: electricityStatistics
        },
        // {
        //   path: 'chargeCabinetMgmt',
        //   name: 'chargeCabinetMgmt',
        //   component: chargeCabinetMgmt
        // },
        // {
        //   path: 'cabinetSetting',
        //   name: 'cabinetSetting',
        //   component: cabinetSetting
        // },
        // {
        //   path: 'chargeMgmt',
        //   name: 'chargeMgmt',
        //   component: chargeMgmt
        // },
        {
          path: 'electricBicycleMgmt',
          name: 'electricBicycleMgmt',
          component: electricBicycleMgmt
        },
        // {
        //   path: 'displayScreenMgmt',
        //   name: 'displayScreenMgmt',
        //   component: displayScreenMgmt
        // },
        // {
        //   path: 'voucherMgmt',
        //   name: 'voucherMgmt',
        //   component: voucherMgmt
        // },
        {
          path: 'snapShot',
          name: 'snapShot',
          component: snapShot
        },
        // {
        //   path: 'snapShotMgmt',
        //   name: 'snapShotMgmt',
        //   component: snapShotMgmt
        // },
        // {
        //   path: 'batteryConsignRecordBatterySnap',
        //   name: 'batteryConsignRecordBatterySnap',
        //   component: batteryConsignRecordBatterySnap
        // },
        {
          path: 'sendRecord',
          name: 'sendRecord',
          component: sendRecord
        },
        // {
        //   path: 'sendRecordMgmt',
        //   name: 'sendRecordMgmt',
        //   component: sendRecordMgmt
        // },
        // {
        //   path: 'batteryConsignSendRequestRecord',
        //   name: 'batteryConsignSendRequestRecord',
        //   component: batteryConsignSendRequestRecord
        // },
        // {
        //   path: 'sendRecordTotal',
        //   name: 'sendRecordTotal',
        //   component: sendRecordTotal
        // },
        // {
        //   path: 'batteryBelongRecord',
        //   name: 'batteryBelongRecord',
        //   component: batteryBelongRecord
        // }, {
        //   path: 'electricBicycleBelongRecord',
        //   name: 'electricBicycleBelongRecord',
        //   component: electricBicycleBelongRecord
        // }, {
        //   path: 'deviceUpgradeTask',
        //   name: 'deviceUpgradeTask',
        //   component: deviceUpgradeTask
        // },
        {
          path: 'stopReason',
          name: 'stopReason',
          component: stopReason
        },
        {
          path: 'batterySnapShot',
          name: 'batterySnapShot',
          component: batterySnapShot
        },
        
        {
          path: 'chargeOrderMgmt',
          name: 'chargeOrderMgmt',
          component: chargeOrderMgmt
        },
        //
        {
          path: 'batterySwapCardOrder',
          name: 'batterySwapCardOrder',
          component: batterySwapCardOrder
        },
        //
        {
          path: 'chargeCabinetOrderMgmt',
          name: 'chargeCabinetOrderMgmt',
          component: chargeCabinetOrderMgmt
        },
        //
        {
          path: 'rentOrderMgmt',
          name: 'rentOrderMgmt',
          component: rentOrderMgmt
        },
        // {
        //   path: 'returnOrderMgmt',
        //   name: 'returnOrderMgmt',
        //   component: returnOrderMgmt
        // },
        //
        {
          path: 'rechargeOrderMgmt',
          name: 'rechargeOrderMgmt',
          component: rechargeOrderMgmt
        },
        // {
        //   path: 'installmentOrderMgmt',
        //   name: 'installmentOrderMgmt',
        //   component: installmentOrderMgmt
        // },
        // {
        //   path: 'unitMgmt',
        //   name: 'unitMgmt',
        //   component: unitMgmt
        // },
        // {
        //   path: 'unitMgmtManageView',
        //   name: 'unitMgmtManageView',
        //   component: unitMgmtManageView
        // },
        // {
        //   path: 'unitMgmtAuthoritySchemeEditView',
        //   name: 'unitMgmtAuthoritySchemeEditView',
        //   component: unitMgmtAuthoritySchemeEditView
        // },
        //
        {
          path: 'userMgmt',
          name: 'userMgmt',
          component: userMgmt
        },
        // {
        //   path: 'authoritySchemeMgmt',
        //   name: 'authoritySchemeMgmt',
        //   component: authoritySchemeMgmt
        // },
        // {
        //   path: 'authoritySchemeMgmtAddView',
        //   name: 'authoritySchemeMgmtAddView',
        //   component: authoritySchemeMgmtAddView
        // },
        // {
        //   path: 'authoritySchemeMgmtEditView',
        //   name: 'authoritySchemeMgmtEditView',
        //   component: authoritySchemeMgmtEditView
        // },
        //
        {
          path: 'batterySwapOrderMgmt',
          name: 'batterySwapOrderMgmt',
          component: batterySwapOrderMgmt
        },
        {
          path: 'commodityMgmt',
          name: 'commodityMgmt',
          component: commodityMgmt
        },
        // {
        //     path: 'marketing',
        //     name: 'marketing',
        //     component: marketing
        // },
        // {
        //   path: 'discount',
        //   name: 'discount',
        //   component: discount
        // },
        // {
        //   path: 'combo',
        //   name: 'combo',
        //   component: combo
        // },
        {
          path: 'downloadTask',
          name: 'downloadTask',
          component: downloadTask
        },
        // {
        //   path: 'warningOverview',
        //   name: 'warningOverview',
        //   component: warningOverview
        // },
        //
        {
          path: 'warningRuleMgmt',
          name: 'warningRuleMgmt',
          component: warningRuleMgmt
        },
        //
        {
          path: 'warningRecord',
          name: 'warningRecord',
          component: warningRecord
        },
        //
        {
          path: 'alermRecord',
          name: 'alermRecord',
          component: alermRecord
        },
        // {
        //   path: 'subAccountMgmt',
        //   name: 'subAccountMgmt',
        //   component: subAccountMgmt
        // },
        // {
        //   path: 'userInviteRecord',
        //   name: 'userInviteRecord',
        //   component: userInviteRecord
        // },
        // {
        //   path: 'batteryConsignRecord',
        //   name: 'batteryConsignRecord',
        //   component: batteryConsignRecord
        // },
        // {
        //   path: 'marketingActivity',
        //   name: 'marketingActivity',
        //   component: marketingActivity
        // },
        // {
        //   path: 'bannerManagement',
        //   name: 'bannerManagement',
        //   component: bannerManagement
        // },
        //
        {
          // 查看详情
          path: 'openCard',
          name: 'openCard',
          component: () => import(/* webpackChunkName: "openCard" */ '@/components/warningMgmt/openCard')
        },
        // {
        //   // 开卡
        //   path: 'activateCard',
        //   name: 'activateCard',
        //   component: () => import(/* webpackChunkName: "activateCard" */ '@/components/newpage/activateCard')
        // }
      ]
    },
    {
      path: '/electricWebview/uploadFile',
      name: 'uploadFile',
      component: uploadFile,
      meta: {
        title: '上传文件'
      }
    },
    {
      path: '/electricWebview/uploadImg',
      name: 'uploadImg',
      component: uploadImg,
      meta: {
        title: '选择图片'
      }
    },
    {path: '*', component: loginPage, name: "default"}
  ]
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };
export default router



// WEBPACK FOOTER //
// ./src/router/router.js